import React from "react";

/**
 * CopyIcon – two stacked squares indicating a “copy” action.
 *
 * Color inherits `currentColor` by default so you can simply set the CSS `color`
 * on a parent element, or pass an explicit `color` prop.
 */
export interface CopyIconProps {
  /** Pixel size for both width & height (defaults to 1em) */
  size?: number | string;
  /** Stroke/fill color (defaults to `currentColor`) */
  color?: string;
  /** Additional class names for custom styling */
  className?: string;
}

const CopyIcon: React.FC<CopyIconProps> = ({
  size = "1em",
  color = "currentColor",
  className = "",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Front square */}
    <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
    {/* Back square */}
    <rect x="3" y="3" width="13" height="13" rx="2" ry="2" />
  </svg>
);

export default CopyIcon;
